<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/product' }">
        <app-i18n code="entities.product.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.product.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.product.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title">
        <app-i18n code="entities.product.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.product.new.title" v-if="!isEditing"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.name.label"
          :prop="fields.name.name"
          :required="fields.name.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.name.name]" ref="focus" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.description.label"
          :prop="fields.description.name"
          :required="fields.description.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :rows="4" type="textarea" v-model="model[fields.description.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.unitPrice.label"
          :prop="fields.unitPrice.name"
          :required="fields.unitPrice.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input-number :precision="fields.unitPrice.scale" :step="0.1" v-model="model[fields.unitPrice.name]" ></el-input-number>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.photos.label"
          :prop="fields.photos.name"
          :required="fields.photos.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-image-upload
              :max="fields.photos.max"
              :path="fields.photos.path"
              :schema="fields.photos.fileSchema"
              v-model="model[fields.photos.name]"
            ></app-image-upload>
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@/shared/form/form-schema';
import { ProductModel } from '@/modules/product/product-model';

const { fields } = ProductModel;
const formSchema = new FormSchema([
  fields.id,
  fields.name,
  fields.description,
  fields.unitPrice,
  fields.photos,
]);

export default {
  name: 'app-product-form-page',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'product/form/record',
      findLoading: 'product/form/findLoading',
      saveLoading: 'product/form/saveLoading',
    }),

    isEditing() {
      return !!this.id;
    },

    fields() {
      return fields;
    },
  },

  async created() {
    if (this.isEditing) {
      await this.doFind(this.id);
    } else {
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'product/form/doFind',
      doNew: 'product/form/doNew',
      doUpdate: 'product/form/doUpdate',
      doCreate: 'product/form/doCreate',
    }),

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {
        return this.doCreate(values);
      }
    },
  },
};
</script>

<style>
</style>
